/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useParams, useNavigate } from "react-router-dom";
import {
  Form,
  FormField,
  FormControl,
  FormItem,
  Button,
  Card,
  CardHeader,
  CardTitle,
  CardContent,
  Textarea,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@repo/ui";
import {
  useSaveCall,
  useGetTicketDetails,
  useSubmitTicket,
  useCreateCall,
} from "services/tickets";
import sweetAlert from "components/sweet-alert";
import FormInput from "ui/Input";
import { PATHS } from "routes/paths";
import FormSelect from "ui/select";
import {
  useLookupActivityTypes,
  useLookupAllAssignmentGroups,
  useLookupCategories,
  useLookupCustomers,
  useLookupMachinesServicePoints,
  useLookupSubCategories,
} from "services/lookups";
import { FormDropdown } from "ui/combo-box";
import { useGetAssignee, useGetEmployeeDetails } from "services/auth";
import Loader from "ui/page-loader";
import { Label } from "ui/label";
import { useGetCustomerDetails } from "services/customers";
import { useGetLocationDetails } from "services/service-points";
import CustomerDetails from "../common/customer-details";
import {
  CREATION_CHANNELS,
  emptyTicket,
  PRIORITIES_LIST,
  TOGGLE,
} from "../constants";
import LocationDetails from "../common/location-details";
import TicketsByLocation from "../common/tickets-by-location";
import UserDetails from "../common/user-details";
import { DateTimePicker } from "@progress/kendo-react-dateinputs";
import { getLocalISODateString } from "utils/date-utils";

const emptyRequest = {
  ...emptyTicket,
  activityType: "Unusual Event",
  assignmentGroup: "Call Center",
};
export default function CreateUnusualEventTicket() {
  const [ticketDetails, setTicketDetails] = useState({ ...emptyRequest });
  const [allAssignmentGroups, setAllAssignmentGroups] = useState([]);
  const params = useParams();
  const navigate = useNavigate();
  const {
    mutate: getCustomersList,
    data: customersListRes,
    isPending: gettingCustomersList,
  } = useLookupCustomers();
  const {
    mutate: getLocationsList,
    data: locationsListRes,
    isPending: gettingLocationsList,
  } = useLookupMachinesServicePoints();
  const {
    mutate: getActivityTypes,
    data: activityTypesRes,
    isPending: gettingActivityTypes,
  } = useLookupActivityTypes();
  const {
    mutate: getCategories,
    data: categoriesRes,
    isPending: gettingCategories,
  } = useLookupCategories();
  const {
    mutate: getSubCategories,
    data: subCategoriesRes,
    isPending: gettingSubCategories,
  } = useLookupSubCategories();

  const {
    mutate: getAllAssignmentGroups,
    data: allAssignmentGroupRes,
    isPending: gettingAllAssignmentGroup,
    reset: resetAllAssignmentGroups,
  } = useLookupAllAssignmentGroups();
  const {
    mutate: getAssigneeList,
    data: assigneeListRes,
    isPending: gettingAssigneeList,
  } = useGetAssignee();

  const {
    mutate: createTicket,
    data: createTicketRes,
    isPending: creatingTicket,
    error: createTicketError,
    reset: resetCreateTicket,
  } = useCreateCall();
  const {
    mutate: saveTicket,
    data: saveTicketRes,
    isPending: savingTicket,
    error: saveTicketError,
    reset: resetSaveTicket,
  } = useSaveCall();
  const {
    mutate: submitTicket,
    data: submitTicketRes,
    isPending: submittingTicket,
    error: submitTicketError,
    reset: resetSubmitTicket,
  } = useSubmitTicket();
  const {
    mutate: getTicket,
    data: ticketDetailsRes,
    isPending: gettingTicket,
    reset: resetDetailsApi,
  } = useGetTicketDetails();

  const {
    mutate: getCustomerDetails,
    data: customerDetailsRes,
    isPending: gettingCustomerDetails,
    error: customerDetailsError,
    // reset: customerDetailsReset,
  } = useGetCustomerDetails();
  const {
    mutate: getAssetDetails,
    data: assetDetailsRes,
    error: assetDetailsError,
  } = useGetLocationDetails();
  const {
    mutate: getUserDetails,
    data: userDetailsRes,
    // isPending: gettingUserDetails,
    error: userDetailsError,
    // reset: userDetailsReset,
  } = useGetEmployeeDetails();

  const form = useForm({
    defaultValues: { ...emptyRequest },
    mode: "onSubmit",
  });
  useEffect(() => {
    getCustomersList();
    getActivityTypes();
    getAllAssignmentGroups();
    onActivityTypeChange("Unusual Event");
    if (params.ticketId) {
      getTicket(params.ticketId);
    }
  }, []);

  useEffect(() => {
    if (form.watch("region") && form.watch("assignmentGroup")) {
      getAssigneeList({
        region: form.getValues("region"),
        assignment: form.getValues("assignmentGroup"),
      });
    }
  }, [form.watch("region"), form.watch("assignmentGroup")]);

  useEffect(() => {
    if (ticketDetailsRes && customersListRes) {
      if (ticketDetailsRes.status === 200) {
        const _details = {
          ...ticketDetailsRes.data,
          alertDateTime: ticketDetailsRes.data.alertDateTime
            ? new Date(ticketDetailsRes.data.alertDateTime)
            : null,
          billingCharges: ticketDetailsRes.data.billingCharges ? "Yes" : "No",
          isCustomerComplaint: ticketDetailsRes.data.isCustomerComplaint
            ? "Yes"
            : "No",
          isChargeable: ticketDetailsRes.data.isChargeable ? "Yes" : "No",
        };
        form.reset({ ...emptyRequest, region: _details.state, ..._details });
        getLocationsList(ticketDetailsRes.data.customerId);
        if (ticketDetailsRes.data.activityType) {
          getCategories(ticketDetailsRes.data.activityType);
        }
        if (ticketDetailsRes.data.category) {
          getSubCategories({
            activityType: ticketDetailsRes.data.activityType,
            category: ticketDetailsRes.data.category,
          });
        }
        getCustomerDetails(_details.customerId);
        if (_details.assetId) {
          getAssetDetails(_details.assetId);
        }
        setTicketDetails({ ..._details });
        resetDetailsApi();
      }
    }

    if (createTicketRes) {
      if (createTicketRes.status && createTicketRes.status === 200) {
        resetCreateTicket();
        navigate(PATHS.openCalls);
        form.reset();
      }
    }
    if (createTicketError) {
      resetCreateTicket();
    }
    if (saveTicketRes) {
      if (saveTicketRes.status && saveTicketRes.status === 200) {
        sweetAlert({
          title: "Operation Successful!",
          text: "Ticket Has Been Saved",
          icon: "success",
        });
        resetSaveTicket();
        navigate(PATHS.openCalls);
        form.reset();
      }
    }
    if (saveTicketError) {
      resetSaveTicket();
    }

    if (submitTicketRes) {
      if (submitTicketRes.status && submitTicketRes.status === 200) {
        resetSubmitTicket();
        navigate(PATHS.openCalls);
        form.reset({ ...emptyRequest });
      }
    }
    if (submitTicketError) {
      resetSubmitTicket();
    }

    if (allAssignmentGroupRes) {
      setAllAssignmentGroups(
        (allAssignmentGroupRes?.data || []).filter((elm) => {
          if (
            [
              "Call Center",
              "Cash Admin",
              "Planning & Analysis",
              "Security & Compliance",
              "CMC Operations-Dubai",
              "EK Outsource",
              "Fleet Management",
              "Business Development",
              "CMC Operations-Abu Dhabi",
              "TG Cash Customer Service",
            ].includes(elm.name)
          ) {
            return true;
          }
          return false;
        }),
      );
      resetAllAssignmentGroups();
    }
  }, [
    createTicketRes,
    createTicketError,
    saveTicketRes,
    saveTicketError,
    ticketDetailsRes,
    submitTicketError,
    submitTicketRes,
    allAssignmentGroupRes,
  ]);

  const generalProps = { errors: form.formState.errors, control: form.control };
  const verificationRules = {
    alertDateTime: { required: "Please Enter Value" },
    customerId: { required: "Please Enter Value" },
    assetId: {},
    customerTicketNo: {
      pattern: {
        value: /^[A-Za-z0-9\s]+$/,
        message: "Invalid Pattern(Only Alphanumeric Allowed)",
      },
    },
    activityType: { required: "Please Enter Value" },
    category: { required: "Please Enter Value" },
    subCategory: { required: "Please Enter Value" },
    assignmentGroup: { required: "Please Enter Value" },
    assigneeId: { required: "Please Enter Value" },
    billingCharges: { required: "Please Enter Value" },
    correlationId: { required: "Please Enter Value" },
    slmEngineer: { required: "Please Enter Value" },
    creationChannel: { required: "Please Enter Value" },
    reportedBy: { required: "Please Enter Value" },
    priority: { required: "Please Enter Value" },
    remarks: { required: "Please Enter Description" },
  };
  const createTicketPayload = () => {
    const _data = form.getValues();
    const payload = {
      alertDateTime: _data.alertDateTime,
      assetId: _data.assetId,
      customerId: _data.customerId,
      region: _data.region,
      customerTicketNo: _data.customerTicketNo,
      activityType: _data.activityType,
      category: _data.category,
      subCategory: _data.subCategory,
      vaultAccessRequired: false,
      assignmentGroup: _data.assignmentGroup,
      assigneeId: _data.assigneeId,
      secondaryAssigneeId: _data.secondaryAssigneeId,
      creationChannel: _data.creationChannel,
      reportedBy: _data.reportedBy,
      auditedBy: _data.auditedBy,
      isChargeable: false,
      isCustomerComplaint: _data.isCustomerComplaint === "Yes",
      billingCharges: false,
      correlationId: _data.correlationId,
      priority: _data.priority
        ? PRIORITIES_LIST.filter((elm) => elm.id === _data.priority)[0].value
        : "",
      remarks: _data.remarks,
    };
    return payload;
  };
  const onSubmit = () => {
    const _data = form.getValues();
    const payload = {
      alertDateTime: getLocalISODateString(_data.alertDateTime),
      ticketId: _data.ticketId,
      assetId: _data.assetId,
      customerId: _data.customerId,
      region: _data.region,
      customerTicketNo: _data.customerTicketNo,
      activityType: _data.activityType,
      category: _data.category,
      subCategory: _data.subCategory,
      vaultAccessRequired: false,
      assignmentGroup: _data.assignmentGroup,
      assigneeId: _data.assigneeId,
      secondaryAssigneeId: _data.secondaryAssigneeId,
      creationChannel: _data.creationChannel,
      reportedBy: _data.reportedBy,
      auditedBy: _data.auditedBy,
      isChargeable: false,
      isCustomerComplaint: _data.isCustomerComplaint === "Yes",
      billingCharges: false,
      correlationId: _data.correlationId,
      priority: _data.priority
        ? PRIORITIES_LIST.filter((elm) => elm.id === _data.priority)[0].value
        : "",
      remarks: _data.remarks,
    };
    submitTicket({ ...payload });
  };
  const onCancel = () => {};
  const onReset = () => {
    form.reset({ ...ticketDetails });
  };

  const onSave = () => {
    createTicket(createTicketPayload());
    // const data = form.getValues();
    // verifyTicket({
    //   assetId: data.assetId,
    //   customerTicketNo: data.customerTicketNo,
    //   activityType: data.activityType,
    //   category: data.category,
    // });
  };

  const onSaveAsDraft = () => {
    const _data = form.getValues();
    const payload = {
      alertDateTime: _data.alertDateTime,
      assetId: _data.assetId,
      customerId: _data.customerId,
      region: _data.region,
      customerTicketNo: _data.customerTicketNo,
      activityType: _data.activityType,
      category: _data.category,
      subCategory: _data.subCategory,
      vaultAccessRequired: false,
      assignmentGroup: _data.assignmentGroup,
      assigneeId: _data.assigneeId,
      secondaryAssigneeId: _data.secondaryAssigneeId,
      creationChannel: _data.creationChannel,
      reportedBy: _data.reportedBy,
      auditedBy: _data.auditedBy,
      isChargeable: false,
      isCustomerComplaint: _data.isCustomerComplaint === "Yes",
      billingCharges: false,
      correlationId: _data.correlationId,
      priority: _data.priority
        ? PRIORITIES_LIST.filter((elm) => elm.id === _data.priority)[0].value
        : "",
      remarks: _data.remarks,
    };
    saveTicket({ ...payload });
  };
  const onCustomerChange = (data) => {
    form.setValue("assetId", "");
    form.setValue("locationName", "");
    form.setValue("region", "");
    form.setValue("assigneeId", "");
    getLocationsList(data);
    getCustomerDetails(data);
  };

  const onAssetChange = (data) => {
    getAssetDetails(data);

    const _asset = locationsListRes?.data.findIndex(
      (elm) => elm.servicePointId === data,
    );
    if (_asset !== -1) {
      form.setValue(
        "locationName",
        locationsListRes?.data[_asset].locationName,
      );
      form.setValue("region", locationsListRes?.data[_asset].state);
    } else {
      form.setValue("locationName", "");
      form.setValue("region", "");
    }
  };
  const onAssignmentGroupChange = (data) => {
    form.setValue("assigneeId", "");
    form.setValue("secondaryAssigneeId", "");
    const _asset = locationsListRes?.data.findIndex(
      (elm) => elm.servicePointId === form.getValues("assetId"),
    );
    if (_asset !== -1) {
      const state = locationsListRes?.data[_asset].state;
      getAssigneeList({ region: state, assignment: data });
    }
  };

  const onActivityTypeChange = (data) => {
    getCategories(data);
  };
  const onCategoryChange = (data) => {
    form.setValue("subCategory", "");
    form.setValue("vaultAccessRequired", "No");
    getSubCategories({
      activityType: form.getValues("activityType"),
      category: data,
    });
  };

  function AccountDetails() {
    if (customerDetailsError && customerDetailsError?.status === 403) {
      return <>User is not authorized to see Details</>;
    }
    if (!form.watch("customerId") || !customerDetailsRes) {
      return <>Select Account To Show Data</>;
    }

    return <CustomerDetails customer={customerDetailsRes.data} />;
  }

  function AssetDetails() {
    if (assetDetailsError && assetDetailsError?.status === 403) {
      return <>User is not authorized to see Details</>;
    }
    if (!form.watch("assetId") || !assetDetailsRes) {
      return <>Select Asset To Show Data</>;
    }

    return <LocationDetails location={assetDetailsRes.data} />;
  }
  function AccountRecords() {
    if (!form.watch("assetId")) {
      return <>Select Asset To Show Data</>;
    }

    return <TicketsByLocation servicePointId={form.watch("assetId")} />;
  }
  function EmployeeDetails() {
    if (userDetailsError && userDetailsError.status === 403) {
      return <>User is not authorized to see Details</>;
    }
    if (!form.watch("assigneeId") || !userDetailsRes) {
      return <>Select Assignee To Show Data</>;
    }

    return <UserDetails user={userDetailsRes.data} />;
  }

  return (
    <>
      {gettingCustomersList ||
      gettingActivityTypes ||
      gettingAssigneeList ||
      savingTicket ||
      creatingTicket ||
      gettingAssigneeList ||
      gettingCategories ||
      gettingLocationsList ||
      gettingTicket ||
      submittingTicket ||
      gettingCustomerDetails ||
      gettingAllAssignmentGroup ||
      gettingSubCategories ? (
        <Loader />
      ) : (
        <></>
      )}

      <div className="form-container">
        <Breadcrumb className="mt-5 text-black">
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbLink>
                <Link to={PATHS.openTickets} className="text-black">
                  Tickets
                </Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator className="text-black" />

            <BreadcrumbItem>
              <BreadcrumbPage className="text-black">
                Create Ticket
              </BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>
        <div className="flex flex-row justify-end w-full gap-2">
          {form.watch("status") !== "Draft" ? (
            <Button variant="secondary" onClick={form.handleSubmit(onSave)}>
              Save
            </Button>
          ) : (
            <Button variant="secondary" onClick={form.handleSubmit(onSubmit)}>
              Submit
            </Button>
          )}

          <Button
            variant="secondary"
            onClick={form.handleSubmit(onSaveAsDraft)}
          >
            Save As Draft
          </Button>
          <Button variant="secondary" onClick={onReset}>
            Reset
          </Button>

          <Link to={PATHS.openTickets}>
            <Button variant="secondary" onClick={onCancel}>
              Cancel
            </Button>
          </Link>
        </div>
        <Card className="form-card shadow-lg mx-0">
          <CardHeader>
            <CardTitle>Unusual Event</CardTitle>
          </CardHeader>
          <Form {...form}>
            <form
              onSubmit={form.handleSubmit(onSubmit)}
              className="space-y-8 custom-form-v2"
            >
              <CardContent className="w-full flex flex-row items-center justify-between flex-wrap gap-4">
                {/* <FormInput
                  {...generalProps}
                  isRequired={true}
                  name={"customerId"}
                  label={"Customer Id"}
                  rules={verificationRules.customerId}
                /> */}
                <div className="form-row-d-50">
                  <FormField
                    control={form.control}
                    name="alertDateTime"
                    rules={verificationRules.alertDateTime}
                    render={({ field }) => (
                      <FormItem>
                        <Label label="Alert Date & Time" isRequired />
                        <div className="form-date-picker">
                          <FormControl>
                            <DateTimePicker
                              variant="secondary"
                              className="px-3 py-2 border border-secondary rounded-md"
                              value={field.value}
                              placeholder="Select Date & Time"
                              onChange={(e) => {
                                field.onChange(e.target.value);
                              }}
                            />
                          </FormControl>
                          {form.formState.errors.alertDateTime ? (
                            <p className="text-destructive text-xs">
                              {form.formState.errors.alertDateTime.message}
                            </p>
                          ) : null}
                        </div>
                      </FormItem>
                    )}
                  />
                </div>
                <div className="form-row-d-50">
                  <FormInput
                    {...generalProps}
                    // isRequired={true}
                    name="reportedBy"
                    label="Reported By"
                    inputProps={{ autoFocus: true }}
                    // rules={verificationRules.reportedBy}
                  />
                  <FormInput
                    {...generalProps}
                    // isRequired={true}
                    name="customerTicketNo"
                    label="Address"
                    onBlur={() => {
                      if (form.watch("customerTicketNo")) {
                        // verifyReference(form.watch("customerTicketNo"));
                      }
                    }}
                    rules={verificationRules.customerTicketNo}
                  />
                  <FormDropdown
                    {...generalProps}
                    label="Account"
                    name="customerId"
                    isRequired
                    data={customersListRes?.data || []}
                    text="name"
                    id="customerId"
                    placeholder="Select Account"
                    rules={verificationRules.customerId}
                    onChange={onCustomerChange}
                    detailsView={AccountDetails()}
                  />
                  <FormSelect
                    {...generalProps}
                    isRequired
                    name="creationChannel"
                    label="Creation Channel"
                    placeholder="Select Creation Channel"
                    data={CREATION_CHANNELS}
                    id="id"
                    text="text"
                    rules={verificationRules.creationChannel}
                  />
                  <FormDropdown
                    {...generalProps}
                    label="Asset ID"
                    name="assetId"
                    placeholder="Select Asset"
                    // disabled={!form.watch("customerId")}
                    data={locationsListRes?.data || []}
                    text="locationId"
                    id="servicePointId"
                    // rules={verificationRules.assetId}
                    onChange={onAssetChange}
                    detailsView={AssetDetails()}
                    recordsView={AccountRecords()}
                    recordContentClass="max-w-[1000px]"
                    info={
                      form.watch("customerId")
                        ? ""
                        : "Select Account To Load Data"
                    }
                  />
                  <FormInput
                    {...generalProps}
                    // isRequired={true}
                    name="locationName"
                    label="Location"
                    inputProps={{ readOnly: true }}
                    // rules={verificationRules.customerTicketNo}
                  />
                  <FormDropdown
                    {...generalProps}
                    label="Activity Type"
                    name="activityType"
                    isRequired
                    placeholder="Select Type"
                    data={activityTypesRes?.data || []}
                    text="description"
                    id="description"
                    rules={verificationRules.activityType}
                    onChange={onActivityTypeChange}
                    disabled
                  />
                  <FormInput
                    {...generalProps}
                    // isRequired={true}
                    name="region"
                    label="Region"
                    inputProps={{ readOnly: true }}
                    // rules={verificationRules.customerTicketNo}
                  />
                  <FormDropdown
                    {...generalProps}
                    label="Category"
                    name="category"
                    isRequired
                    placeholder="Select Category"
                    data={categoriesRes?.data || []}
                    text="description"
                    id="description"
                    rules={verificationRules.category}
                    onChange={onCategoryChange}
                    info={
                      form.watch("activityType")
                        ? ""
                        : "Select Activity Type To Load Data"
                    }
                  />
                  <FormDropdown
                    {...generalProps}
                    label="Assignment Group"
                    name="assignmentGroup"
                    // isRequired={true}
                    // disabled={
                    //   !form.watch("assetId") || !form.watch("activityType")
                    // }
                    placeholder="Select Assignment Group"
                    data={allAssignmentGroups || []}
                    text="name"
                    id="name"
                    onChange={onAssignmentGroupChange}
                    // rules={verificationRules.assignmentGroup}
                  />
                  <FormDropdown
                    {...generalProps}
                    label="Sub Category"
                    name="subCategory"
                    isRequired
                    placeholder="Select Sub Category"
                    rules={verificationRules.subCategory}
                    data={subCategoriesRes?.data || []}
                    text="description"
                    id="description"
                    info={
                      form.watch("activityType") && form.watch("category")
                        ? ""
                        : "Select Activity Type & Category To Load Data"
                    }
                    onChange={(e) => {
                      const currentSubCategoryIndex =
                        subCategoriesRes?.data.findIndex(
                          (elm) => elm.description === e,
                        );
                      if (
                        currentSubCategoryIndex !== -1 &&
                        currentSubCategoryIndex !== undefined
                      ) {
                        const subCategory =
                          subCategoriesRes.data[currentSubCategoryIndex];

                        if (subCategory.vaultAccessRequired) {
                          form.setValue("vaultAccessRequired", "Yes");
                        } else {
                          form.setValue("vaultAccessRequired", "No");
                        }
                      }
                    }}
                  />
                  <FormDropdown
                    {...generalProps}
                    label="Assigned To"
                    name="assigneeId"
                    // isRequired={true}
                    placeholder="Select Assignee"
                    // disabled={!form.watch("customerId")}
                    data={assigneeListRes?.data || []}
                    text="name"
                    id="employeeId"
                    onChange={(data) => {
                      getUserDetails(data);
                    }}
                    detailsView={EmployeeDetails()}
                    info={
                      form.watch("customerId") &&
                      form.watch("assetId") &&
                      form.watch("assignmentGroup")
                        ? ""
                        : "Select Account, Assignment Group & Asset To Load Data"
                    }
                  />
                  <FormSelect
                    {...generalProps}
                    // isRequired={true}
                    name="priority"
                    label="Priority"
                    placeholder="Select Priority"
                    data={PRIORITIES_LIST}
                    id="id"
                    text="text"
                  />
                  <FormSelect
                    {...generalProps}
                    isRequired
                    name="isCustomerComplaint"
                    label="Customer Complaint"
                    placeholder="Select Is Customer Complaint"
                    data={TOGGLE}
                    id="text"
                    text="text"
                  />
                  {/* <FormInput
                    {...generalProps}
                    // isRequired={true}
                    name="correlationId"
                    label="Correlation Id"
                    // rules={verificationRules.correlationId}
                  /> */}
                  {/* {form.watch("customerId") === "66e42d5af405de06de469b79" ? (
                    <FormInput
                      {...generalProps}
                      // isRequired={true}
                      name="secondaryAssigneeId"
                      label="Secondary Assignee Id"
                    />
                  ) : (
                    <></>
                  )} */}
                </div>
                <div className="flex flex-col gap-inherit w-full mt-6">
                  <FormField
                    control={form.control}
                    name="remarks"
                    rules={verificationRules.remarks}
                    render={({ field }) => (
                      <FormItem>
                        <div className="flex flex-col gap-6 w-full">
                          <Label
                            label="Description"
                            isRequired
                            style={{
                              justifyContent: "flex-start",
                              textAlign: "left",
                            }}
                          />

                          <div>
                            <FormControl>
                              <Textarea
                                {...field}
                                className="min-w-full"
                                style={
                                  form.formState?.errors?.remarks
                                    ? {
                                        borderColor: "red",
                                      }
                                    : {}
                                }
                              />
                            </FormControl>
                            {form.formState?.errors &&
                            form.formState?.errors.remarks ? (
                              <p className="text-destructive text-xs">
                                {form.formState.errors.remarks.message}
                              </p>
                            ) : (
                              <></>
                            )}
                          </div>
                        </div>
                      </FormItem>
                    )}
                  />
                </div>
              </CardContent>
            </form>
          </Form>
        </Card>
      </div>
    </>
  );
}
